var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-views-shell"},[_c('BenefitCardListPanel',{ref:"listPanel"}),_c('AllNav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }